import React from 'react';
import $image_url from 'js/utils/image_url';
import pluralize from 'pluralize';
import {
  BulkDownloadFilterCounts,
  BulkDownloadFilter,
} from 'js/bulk_download/bulk_download_helper';

interface BulkDownloadDescriptionProps {
  filterCounts: BulkDownloadFilterCounts;
}

// descriptions of each bulk download filter
const filterToDescription: {
  [P in BulkDownloadFilter]: (n: number) => string;
} = {
  // Can't use pluralize here because it returns 'PDFS' instead of 'PDFs'
  topRelated: (n) =>
    `${n} most-viewed PDF${n === 1 ? '' : 's'} similar to this paper`,
  sameAuthor: (n) => `${n} more ${pluralize('paper', n)} by this author`,
  citingThis: (n) => `${n} ${pluralize('paper', n)} citing this one`,
  citedByThis: (n) => `${n} ${pluralize('paper', n)} cited by this one`,
};

function totalFilterCount(filterCounts: BulkDownloadFilterCounts) {
  return Object.values(filterCounts).reduce((a: number, b) => a + (b || 0), 0);
}

export function BulkDownloadDescription(props: BulkDownloadDescriptionProps) {
  const { filterCounts } = props;
  const totalCount = totalFilterCount(filterCounts);

  return (
    <div className="all-products-modal-product-container">
      <div className="all-products-modal-product-icon-container">
        <div className="all-products-modal-bulk-download-icon-container">
          <img src={$image_url('pdf-folder-new.png')}></img>
          <div className="all-products-modal-bulk-download-text-container">
            <div className="all-products-modal-bulk-download-paper-count">
              {totalCount}
            </div>
            <div className="all-products-modal-bulk-download-text">PDFs</div>
          </div>
        </div>
      </div>
      <div className="all-products-modal-product-features-container">
        <h3 className="all-products-modal-product-features-heading">
          {totalCount + ' PDFs related to this paper'}
        </h3>
        {(Object.keys(filterCounts) as (keyof BulkDownloadFilterCounts)[]).map(
          (f, index) => {
            return (
              <div key={index} className="all-products-modal-product-feature">
                <div className="all-products-modal-product-checkmark">
                  <i className="fa fa-check" />
                </div>
                <div>{filterToDescription[f](filterCounts[f] as number)}</div>
              </div>
            );
          },
        )}
      </div>
    </div>
  );
}
